import { render } from "./HeadNav.vue?vue&type=template&id=70a071af&scoped=true"
import script from "./HeadNav.vue?vue&type=script&lang=js"
export * from "./HeadNav.vue?vue&type=script&lang=js"

import "./HeadNav.vue?vue&type=style&index=0&id=70a071af&scoped=true&lang=css"

import exportComponent from "/Users/ezink/Downloads/海/vue-antd-tool-web 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a071af"]])

export default __exports__